import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";

// Schema
export const profileSchema = itemSchema.extend({
  network: z.string().min(1, { message: "Please Select Profile" }),
  username: z.string(),
  icon: z.string(),
  url: urlSchema,
});

// Type
export type Profile = z.infer<typeof profileSchema>;

export const defaultProfile: Profile = {
  ...defaultItem,
  network: "",
  username: "",
  icon: "",
  url: defaultUrl,
};
